module.exports = __webpack_public_path__ + "img/icons-push-popup.5b0f460a.svg";